import React from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import s from './PrimisTutorialsWrapper.scss';
export const PrimisTutorialsWrapper = ({ children, hasPrimis })=>{
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement("div", {
        "aria-hidden": true,
        className: classnames(s['ad-slot'], hasPrimis && s['primis'])
    }, children, hasPrimis && /*#__PURE__*/ React.createElement("div", {
        className: s['primis-text']
    }, /*#__PURE__*/ React.createElement("h3", null, t('ads.video.popular.tuts.heading')), /*#__PURE__*/ React.createElement("p", null, t('ads.video.popular.tuts.subheading')), /*#__PURE__*/ React.createElement("p", null, /*#__PURE__*/ React.createElement("a", {
        href: t('ads.video.popular.tuts.one.link')
    }, t('ads.video.popular.tuts.one.text'))), /*#__PURE__*/ React.createElement("p", null, /*#__PURE__*/ React.createElement("a", {
        href: t('ads.video.popular.tuts.two.link')
    }, t('ads.video.popular.tuts.two.text'))), /*#__PURE__*/ React.createElement("p", null, /*#__PURE__*/ React.createElement("a", {
        href: t('ads.video.popular.tuts.three.link')
    }, t('ads.video.popular.tuts.three.text')))));
};
PrimisTutorialsWrapper.displayName = 'PrimisTutorialsWrapper';
export default PrimisTutorialsWrapper;
